<template>
  <div class="docs">
    <h1 class="page-title">开发文档</h1>
	<p class="page-desc">
	   开发文档
	 </p>
   <!-- <p class="page-desc">
      Base：<code class="mono">{{ baseDisplay || 'https://open.pluskeji.cn' }}</code>
      · 域名：<code class="mono">open.pluskeji.cn</code>（与主站剥离）
      · 对外：CORS + OPTIONS
      · 鉴权：OpenGate <code class="mono">og_live_*</code> + <code class="mono">X-Api-Secret</code>
      · 条件：主站用户积分余额 &gt; 0
      · 实现：<code class="mono">IdoingProductController</code>
    </p> -->

    <!-- <section class="panel docs__intro">
      <h2 class="docs__h" style="margin-top: 0">外部接入</h2>
      <ol class="docs__ol">
        <li>先 <code class="mono">GET /idoing_ping</code>（无需鉴权）确认域名可达。</li>
        <li>后端部署 <code class="mono">IdoingProductController.php</code>，合并 <code class="mono">api.php</code> / 路由示例（含 OPTIONS）。</li>
        <li>配置服务端 <code class="mono">IDOING_API_KEY</code>（上游密钥），切勿下发客户端。</li>
        <li>在开放平台「密钥」页创建 Key/Secret，写入 <code class="mono">users.opengate_api_keys</code>。</li>
        <li>外部请求带 <code class="mono">Authorization: og_live_xxx</code> 与 <code class="mono">X-Api-Secret</code>；按 <code class="mono">opengate_models</code> 扣费。</li>
        <li>异步接口先 POST 拿 <code class="mono">task_id</code>，再 GET <code class="mono">/idoing_video/{id}</code> 或 <code class="mono">/idoing_task/{id}</code> 轮询。</li>
      </ol>
      <p class="docs__link">
        完整说明：仓库
        <code class="mono">IdoingProductController.php</code>
      </p>
    </section> -->

    <div class="docs__layout">
      <aside class="docs__side panel">
        <div v-for="g in groups" :key="g.id" class="docs__group">
          <div class="docs__group-name">{{ g.name }}</div>
          <button
            v-for="ep in g.endpoints"
            :key="ep.id"
            type="button"
            class="docs__ep"
            :class="{ 'is-active': activeId === ep.id }"
            @click="select(ep.id)"
          >
            <span class="badge" :class="'badge-' + ep.method.toLowerCase()">{{ ep.method }}</span>
            <span class="docs__ep-path mono">{{ ep.path }}</span>
          </button>
        </div>
      </aside>

      <section v-if="current" class="docs__main panel">
        <div class="docs__head">
          <span class="badge" :class="'badge-' + current.method.toLowerCase()">{{ current.method }}</span>
          <h2 class="mono">{{ current.path }}</h2>
        </div>
        <p class="docs__summary">{{ current.summary }}</p>
        <p v-if="current.controller" class="docs__meta mono">控制器：{{ current.controller }}</p>
        <h3 class="docs__h">参数</h3>
        <div class="docs__table-wrap">
          <table class="docs__table">
            <thead>
              <tr>
                <th>名称</th>
                <th>位置</th>
                <th>类型</th>
                <th>必填</th>
                <th>说明</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="p in current.params" :key="p.name + p.in">
                <td class="mono">{{ p.name }}</td>
                <td>{{ p.in }}</td>
                <td class="mono">{{ p.type }}</td>
                <td>{{ p.required ? '是' : '否' }}</td>
                <td>{{ p.desc }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <h3 class="docs__h">cURL</h3>
        <pre class="docs__pre mono">{{ curlSample }}</pre>

        <template v-if="current.sampleBody">
          <h3 class="docs__h">请求 Body</h3>
          <pre class="docs__pre mono">{{ pretty(current.sampleBody) }}</pre>
        </template>

        <h3 class="docs__h">响应示例</h3>
        <pre class="docs__pre mono">{{ pretty(current.sampleResponse) }}</pre>

        <router-link
          class="btn btn-primary"
          :to="{ path: '/playground', query: { id: current.id } }"
        >
          在调试台打开
        </router-link>
      </section>
    </div>
  </div>
</template>

<script>
import { API_BASE, apiGroups, findEndpoint, resolveRequestUrl } from '../data/apiCatalog'

export default {
  name: 'Docs',
  data() {
    const qid = this.$route.query.id
    const first =
      (qid && findEndpoint(qid) && qid) ||
      (apiGroups[0] && apiGroups[0].endpoints[0] && apiGroups[0].endpoints[0].id) ||
      'gpt-image'
    return {
      groups: apiGroups,
      activeId: first
    }
  },
  computed: {
    baseDisplay() {
      return API_BASE || ''
    },
    current() {
      const hit = findEndpoint(this.activeId)
      return hit ? hit.endpoint : null
    },
    curlSample() {
      if (!this.current) return ''
      const pathParams = this.current.samplePathParams || {}
      const url = resolveRequestUrl(this.current.path, pathParams)
      const full =
        url.startsWith('http') ? url : `https://open.pluskeji.cn${url.startsWith('/') ? url : '/' + url}`
      const method = this.current.method.toUpperCase()
      let s =
        `curl -X ${method} '${full}' \\\n` +
        `  -H 'Authorization: og_live_xxx' \\\n` +
        `  -H 'X-Api-Secret: sk_xxx' \\\n` +
        `  -H 'Accept: application/json'`
      if (method !== 'GET' && this.current.sampleBody) {
        s += ` \\\n  -H 'Content-Type: application/json' \\\n  -d '${JSON.stringify(this.current.sampleBody)}'`
      }
      return s
    }
  },
  watch: {
    '$route.query.id'(id) {
      if (id && findEndpoint(id)) this.activeId = id
    }
  },
  methods: {
    select(id) {
      this.activeId = id
      if (this.$route.query.id !== id) {
        this.$router.replace({ query: { ...this.$route.query, id } }).catch(() => {})
      }
    },
    pretty(obj) {
      return JSON.stringify(obj, null, 2)
    }
  }
}
</script>

<style scoped>
.docs__intro {
  margin-bottom: 16px;
  padding: 16px 18px;
}
.docs__ol {
  margin: 0;
  padding-left: 1.2em;
  color: #475569;
  line-height: 1.7;
  font-size: 14px;
}
.docs__link {
  margin: 12px 0 0;
  font-size: 13px;
  color: #64748b;
}
.docs__layout {
  display: grid;
  gap: 16px;
}
@media (min-width: 900px) {
  .docs__layout {
    grid-template-columns: 280px 1fr;
    align-items: start;
  }
}
.docs__side {
  padding: 12px;
  position: sticky;
  top: 72px;
}
.docs__group + .docs__group {
  margin-top: 14px;
}
.docs__group-name {
  font-size: 12px;
  font-weight: 600;
  color: #64748b;
  margin-bottom: 6px;
  padding: 0 6px;
}
.docs__ep {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  text-align: left;
  border: 0;
  border-left: 2px solid transparent;
  background: transparent;
  padding: 9px 10px 9px 8px;
  border-radius: 0 8px 8px 0;
  cursor: pointer;
  font-size: 12px;
  color: var(--text);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.docs__ep:hover {
  background: rgba(125, 255, 179, 0.06);
  color: var(--text);
}
.docs__ep.is-active {
  background: rgba(125, 255, 179, 0.1);
  border-left-color: var(--accent);
  color: var(--accent);
}
.docs__ep.is-active .docs__ep-path {
  color: var(--accent);
  font-weight: 600;
}
.docs__ep-path {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: inherit;
}
.docs__main {
  padding: 20px;
}
.docs__head {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.docs__head h2 {
  margin: 0;
  font-size: 18px;
}
.docs__summary {
  color: #475569;
  margin: 10px 0;
}
.docs__meta {
  margin: 4px 0;
  font-size: 12px;
  color: #64748b;
}
.docs__meta a {
  color: #0f766e;
}
.docs__h {
  margin: 20px 0 10px;
  font-size: 15px;
}
.docs__table-wrap {
  overflow: auto;
}
.docs__table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.docs__table th,
.docs__table td {
  border-bottom: 1px solid #e2e8f0;
  padding: 8px 10px;
  text-align: left;
  vertical-align: top;
}
.docs__table th {
  color: #64748b;
  font-weight: 600;
}
.docs__pre {
  margin: 0;
  padding: 12px;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 8px;
  overflow: auto;
  font-size: 12px;
  line-height: 1.5;
}
</style>
